<template>
  <div>
    <md-progress-bar md-mode="indeterminate" v-if="loading" />

    <md-empty-state
      v-else-if="loadError"
      md-label="Unable to load reservations"
      :md-description="loadError"
    />

    <div v-else-if="groupedReservations.length" class="reservations-table-wrap">
      <md-table class="reservations-grouped-table">
        <template v-for="group in groupedReservations">
          <md-table-row
            :key="`${group.key}-title`"
            class="reservation-group-title-row"
          >
            <md-table-cell colspan="20" class="reservation-group-title-cell">
              <div class="md-layout md-alignment-start-center">
                <h6>
                  {{ group.tourTitle }} - Departure:
                  {{ group.departureLabel }} |
                  {{
                    group.peopleCount != null ? "Travellers" : "Reservations"
                  }}:
                  {{
                    group.peopleCount != null
                      ? group.peopleCount
                      : group.rows.length
                  }}
                </h6>
              </div>
            </md-table-cell>
          </md-table-row>

          <md-table-row
            :key="`${group.key}-header`"
            class="summary-header reservations-header"
          >
            <slot name="header"></slot>
          </md-table-row>

          <template v-for="item in group.rows">
            <slot name="row" :item="item"></slot>
            <md-table-row
              :key="`${item.key}-notes`"
              v-show="isNotesExpanded(item.key)"
            >
              <md-table-cell
                colspan="20"
                class="summary-reservations notes-panel"
              >
                <slot name="notes" :item="item"></slot>
              </md-table-cell>
            </md-table-row>
          </template>
        </template>
      </md-table>
    </div>

    <md-empty-state
      v-else
      md-label="No reservations found"
      :md-description="emptyDescription"
    />
  </div>
</template>

<script>
export default {
  name: "ReservationsGroupedList",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loadError: {
      type: String,
      default: null
    },
    groupedReservations: {
      type: Array,
      default: () => []
    },
    expandedNotes: {
      type: Object,
      default: () => ({})
    },
    emptyDescription: {
      type: String,
      default: "No reservations found."
    }
  },
  methods: {
    isNotesExpanded(key) {
      return Boolean(this.expandedNotes[key]);
    }
  }
};
</script>

<style lang="scss" scoped>
.reservations-table-wrap {
  overflow-x: auto;
  width: 100%;
}

::v-deep .reservations-grouped-table,
::v-deep .reservations-grouped-table .md-table-content,
::v-deep .reservations-grouped-table table {
  width: 100%;
}

::v-deep .reservations-grouped-table .md-table-cell-container {
  padding: 0;
  text-align: left;
}

::v-deep .reservation-group-title-cell h6 {
  margin: 6px 0;
  text-align: left;
}

::v-deep .reservations-grouped-table .notes-panel {
  text-align: left;
}

::v-deep .reservations-grouped-table .notes-panel .md-table-cell-container {
  justify-content: flex-start;
}
</style>
